// Sacrifice (Neptune): the constellation surrounding Neptune scores nothing;
// every other constellation scores more.
import { ALIGNMENT_NUMBERS as N } from '../constants';
import { ownIndex } from '../shared/own';
import type { AlignmentDef } from '../types';

export const sacrifice: AlignmentDef = {
  id: 'sacrifice',
  planet: 'neptune',
  name: 'Sacrifice',
  text: () => `The constellation that surrounds Neptune scores 0. Every other constellation scores +${N.sacrificePercent}%.`,
  standing: (entries, ctx) => {
    const own = ownIndex(ctx, 'sacrifice');
    return entries.map((e) => (e.index === own ? { index: e.index, zero: true } : { index: e.index, percent: N.sacrificePercent }));
  },
};
